import {
  Box,
  Typography,
  Divider,
  TextField,
  Button,
  Collapse,
  Alert,
  CircularProgress,
  Grid,
} from '@mui/material';
import ReportIcon from '@mui/icons-material/Report';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import CloseButton from '../../../../components/closebutton/CloseButton';
import { PermissionCreateModel } from '../../model/permission.model';
import { permissionCreateSchema } from '../../model/permission.schema';

interface Props {
  loading: boolean;
  message: string | null;
  onClose: () => void;
  onSubmit: (form: PermissionCreateModel) => void;
}

const PermissionModalCreate = ({ loading, message, onClose, onSubmit }: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<PermissionCreateModel>({
    resolver: yupResolver(permissionCreateSchema),
    defaultValues: { module: 'mseg' },
  });

  return (
    <Box sx={{ width: '100%' }}>
      <Box padding={4}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography fontSize="24px">ສ້າງສິດທິໃໝ່</Typography>
          <CloseButton onClick={onClose} />
        </Box>
        <Divider sx={{ backgroundColor: '#1A1A1A20', mt: 1.5, mb: 2.5 }} />

        <Collapse unmountOnExit orientation="vertical" in={!!message}>
          <Alert severity="error" sx={{ mb: 2 }}>
            {message ?? ''}
          </Alert>
        </Collapse>

        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container marginTop="10px" spacing={3}>
            <Grid item md={8} xs={12}>
              <TextField
                fullWidth
                size="small"
                InputLabelProps={{ shrink: true }}
                label="ລະຫັດສິດທິ (code)"
                placeholder="mseg:document:create"
                error={!!errors.code}
                helperText={errors.code?.message}
                {...register('code')}
              />
            </Grid>
            <Grid item md={4} xs={12}>
              <TextField
                fullWidth
                size="small"
                InputLabelProps={{ shrink: true }}
                label="Module"
                placeholder="mseg"
                error={!!errors.module}
                helperText={errors.module?.message}
                {...register('module')}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                InputLabelProps={{ shrink: true }}
                label="ຊື່ສິດທິ"
                placeholder="Create Document"
                error={!!errors.name}
                helperText={errors.name?.message}
                {...register('name')}
              />
            </Grid>
          </Grid>

          <Box mt="20px" />
          <TextField
            fullWidth
            size="small"
            multiline
            rows={3}
            InputLabelProps={{ shrink: true }}
            label="ຄໍາອະທິບາຍ"
            placeholder="ປ້ອນຄໍາອະທິບາຍ"
            {...register('description')}
          />

          <Box
            sx={{
              flexDirection: 'row',
              display: 'flex',
              marginTop: '15px',
              alignItems: 'center',
            }}
          >
            <ReportIcon sx={{ color: '#DCDCDC', width: '16px', marginRight: '5px' }} />
            <Typography sx={{ color: '#808080', fontSize: 13 }}>
              ລະຫັດຕ້ອງກົງກັບທີ່ລະບົບກວດສອບຢູ່ຫຼັງບ້ານ, ສິດທິໃໝ່ຈະມີຜົນເມື່ອຖືກນຳໃຊ້ໃນ API ແລ້ວ
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', gap: 2, mt: '30px' }}>
            <Button
              onClick={onClose}
              sx={{ flexGrow: 1, borderRadius: '100px', height: '41px' }}
              variant="outlined"
              size="small"
              fullWidth
            >
              ຍົກເລີກ
            </Button>
            <Button
              type="submit"
              sx={{ flexGrow: 1, borderRadius: '100px', height: '41px' }}
              size="small"
              fullWidth
              variant="contained"
              disabled={loading}
            >
              <Collapse unmountOnExit orientation="horizontal" in={loading}>
                <CircularProgress size="20px" sx={{ color: 'white', marginRight: '10px' }} />
              </Collapse>
              ບັນທຶກ
            </Button>
          </Box>
        </form>
      </Box>
    </Box>
  );
};

export default PermissionModalCreate;
